/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.social_media_share_button
 */
function socialMediaShareButtonDirective() {
    return {
        restrict: 'E',
        bindToController: true,
        scope: {
            sharingSite: '@',
            sharedLink: '<?',
            messageType: '@',
        },
        controllerAs: 'vm',
        controller: socialMediaShareButtonController,
        template: require('./socialMediaShareButtonView.html'),
    };
};

socialMediaShareButtonController.$inject = [
    '$location',
    'UtilService',
    'CmsContentService',
    'AnalyticsService'
];
function socialMediaShareButtonController (
    $location,
    UtilService,
    CmsContentService,
    AnalyticsService
) {
    const vm = this;
    vm.sharedLink = vm.sharedLink || UtilService.getSiteSetting('product_api_base_url');

    /**
     * Gets message text being shared from the CMS.
     */
    function getSharedText() {
        return CmsContentService.getMarketPlaceText(
            `social_media_share:${vm.sharingSite}_share_message_${vm.messageType}`
        );
    };

    /**
     * Lets us share a custom link, or else it just links to the site base url from settings.
     * Everything is URI encoded just incase the browser doesn't do it automatically.
     * shared.message uses "\n\n" to keep message and link on separate lines
     * @return {String}
     */
    vm.formatSocialMediaLink = () => {
        if (!vm.sharedText) {
            getSharedText().then(text => vm.sharedText = text);
        };
        const shared = {
            message: encodeURIComponent(`${vm.sharedText}\n\n`),
            link: encodeURIComponent(vm.sharedLink),
        };
        const urls = {
            facebook: `http://www.facebook.com/sharer/sharer.php?quote=${shared.message}&u=${shared.link}`,
            twitter: `http://www.twitter.com/intent/tweet?text=${shared.message}&url=${shared.link}`,
        };

        return urls[vm.sharingSite];
    };

    /**
     * Report when button is clicked
     */
    vm.reportClick = function () {
        AnalyticsService.reportEvent('Social Media Button Engaged', {
            path: $location.path(),
            sharingSite: vm.sharingSite,
            sharedLink: vm.sharedLink
        });
    };
};

module.exports = socialMediaShareButtonDirective;
